<template>
  <div class="session">
    <div class="session-content" dir="rtl">
      <div v-if="true">
        <iframe
          v-if="googleEmbedURL"
          :src="googleEmbedURL"
          frameborder="0"
          width="960"
          height="569"
          allowfullscreen="false"
          mozallowfullscreen="true"
          webkitallowfullscreen="true"
        />
        <div v-else>Sorry, no slide</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import RecordViews from "@/mixins/RecordViews";

export default {
  name: "PresentationRoom",
  components: {},
  computed: {
    ...mapGetters({}),
    googleEmbedURL() {
      const slides = this.presentation.slides;
      if (slides) {
        return `${slides.url}?start=${
          slides.autoStart ? "true" : "false"
        }&loop=${slides.loop ? "true" : "false"}&delayms=${slides.delay}`;
      }
      return null;
    }
  },
  props: {
    presentation: {
      type: Object,
      required: true
    }
  },
  mounted() {
    if (this.presentation.id) {
      this.recordFeedback(this.presentation.id);
    }
    this.conjureTS = moment().unix();
  },
  mixins: [RecordViews],
  methods: {
    recordFeedback(presentationId) {
      this.$store.dispatch("listings/recordFeedback", {
        userId: this.user ? this.user.uid : null,
        pathId: "presentations",
        entityId: presentationId,
        sessionId: this.checkSession("session"),
        feedbackType: "views"
      });
    }
  },
  data() {
    return {
      slide: 0,
      sliding: null,
      timerId: null
    };
  },
  watch: {
    presentation(newValue, oldValue) {
      if (newValue.id) {
        this.recordView(this.presentation.id);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.session {
  .overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 3;
    background: transparent;
  }
  .session-content {
    position: relative;
    min-height: calc(100vh - 140px);
    width: calc(100vw);
    padding-top: 120px;
    .remote-video {
      width: 100%;
      height: 100%;
      margin-top: -190px;
    }
    .notes-area {
      float: right;
      margin-right: 24px;
      display: grid;

      grid-template-rows: 154px 154px;
      grid-gap: 10px;
      grid-template-columns: repeat(auto-fill, 144px);
      grid-auto-flow: column;
      justify-content: end;
      z-index: 500;
    }
    .take-note {
      cursor: pointer;
      position: absolute;
      top: 24px;
      right: 24px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      width: 100px;
      height: 70px;
      background: rgb(85, 126, 251);
      background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' stroke='white' stroke-width='2' stroke-dasharray='6' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e");

      span {
        font-family: "Nunito", sans-serif;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 19px;
        color: #ffffff;
      }
      &:hover {
        box-shadow: 0px 0px 4px 0px #888;
      }
    }
  }
  .profile__session {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 104px;

    img {
      width: 80px;
      height: 80px;
      border-radius: 50%;
      cursor: pointer;
    }
    h3 {
      cursor: pointer;
      font-family: "Nunito", sans-serif;
      font-style: normal;
      font-weight: 600;
      font-size: 24px;
      line-height: 33px;
      color: #ffffff;
    }
    button {
      padding: 0;
      width: 84px;
      height: 28px;
      background: #557efb;
      border-radius: 4px;
      font-family: "Nunito", sans-serif;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 19px;
      color: #ffffff;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .local-video {
    width: 100%;
    height: 100%;
    z-index: 5;
    background-color: #8d99a0;
  }
  .local-levels {
    svg {
      position: absolute;
      left: 252px;
      bottom: 2px;
    }
  }
}
// @media (max-width: 991px) {
//   .local-video {
//     position: fixed !important;
//     width: 100px;
//     bottom: 105px !important;
//   }
// }

@media (max-width: 768px) {
  .session-content {
    display: flex;
    justify-content: center;
  }
  .session .session-content {
    padding-top: 180px;
  }
  .session .profile__session {
    top: 10px;
  }
  .session-content .notes-area {
    margin: 0 5%;
    grid-auto-flow: row !important;
    grid-template-columns: 144px 144px !important;
    grid-template-rows: repeat(auto-fill, 154px) !important;
  }
}
@media (max-width: 560px) {
  .setting {
    bottom: 130px !important;
    width: 100%;
    min-width: unset;
    .settings .set__settings .form-control {
      width: 50%;
    }
  }
}
</style>
